import { isObject, isNil } from 'lodash';

export const SOURCE_RASTER = 'raster';
export const SOURCE_VECTOR = 'vector';
export const SOURCE_WMS = 'wms';

function getThemeBasedStyle(theme, rasterStyleFactory, vectorStyleFactory, wmsStyleFactory) {
    switch (theme.source) {
    case SOURCE_RASTER:
        if (isNil(rasterStyleFactory)) {
            throw new Error('Raster source is not supported');
        }
        return rasterStyleFactory();
    case SOURCE_VECTOR:
        if (isNil(vectorStyleFactory)) {
            throw new Error('Vector source is not supported');
        }
        return vectorStyleFactory();
    case SOURCE_WMS:
        if (isNil(wmsStyleFactory)) {
            throw new Error('WMS source is not supported');
        }
        return wmsStyleFactory();
    default:
        throw new Error('Unknown theme source: ' + theme.source);
    }
}

export default (theme, rasterStyleFactory, vectorStyleFactory, wmsStyleFactory) => {
    if (isObject(theme)) {
        return getThemeBasedStyle(theme, rasterStyleFactory, vectorStyleFactory, wmsStyleFactory);
    }

    return theme;
};



// WEBPACK FOOTER //
// ./map/tier/styleParts/styleResolver.js